export default "__VITE_ASSET__Dv15FUKs__"